jQuery(document).ready(function () {
  ajaxCart();
});

function ajaxCart() {


  jQuery(document).on("click", ".ajax-add-selected-items", function () {
    var url = jQuery(this).attr("data-url");
    var dataType = [];
    jQuery(".cart-lists--content")
      .find(".list.active")
      .each(function () {
        var data = {};
        data["id"] = jQuery(this).attr("data-id");
        data["quantity"] = parseInt(jQuery(this).find(".input-val").text());
        dataType.push(data);
      });
    const newData = {
      items: dataType,
    };
    console.log(newData);
    jQuery.ajax({
      url: "/cart/add.js",
      type: "post",
      dataType: "json",
      data: newData,
      success: function (msg) {
        console.log(msg);
        jQuery.ajax({
            url: url,
            type: "GET",
            dataType: "html",
          }).done(function (html) {
            
            var cart = jQuery(html).find('.cart-drawer');
          // console.log(cart.html());
            jQuery(".cart-drawer").html(cart.html());
          });
      },
    });
  });
}
